export class EndBeforeStartError extends Error {}
